// extracted by mini-css-extract-plugin
module.exports = {"bookNow":"BookNow-module--bookNow--3ohWt"};